import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';
import router from "@/router";

export default {
    name: 'educationTest',

    data() {
        return {
            quiz: {},
            answer: {},
            answers: [],
            quizCount: 0
        };
    },

    components: {
        BaseLayout
    },

    computed: {
        quizId: function () {
            return this.$route.params.id;
        },

        questionId: function () {
            return this.$route.params.questionId || null;
        }
    },

    methods: {
        /**
         * Gets the education video from API
         */
        getQuiz() {
            api.get(`/api/get_promotion_education_quiz_question/${this.$route.params.id}`)
                .then((response) => {
                    this.quiz = response.data.body.entries;
                    this.answer = response.data.body.entries.answers[this.quizCount];

                    if (!this.quiz.active && this.quiz.archived) {
                        router.replace('/education/tests')
                    }
                });
        },

        saveAnswer(questionId) {
            api.post(`/api/submit_answers_promotion_education_quiz_question/${this.$route.params.id}/${questionId}`, {answers: this.answers})
                .then(() => {
                    this.answers = [];
                    this.quizCount = this.quizCount + 1;
                    this.answer = this.quiz.answers[this.quizCount];
                })
        }
    },

    mounted() {
        this.getQuiz();
    },
}
